<template>
    <hts-drawer
        v-model="visible"
        :rules="form.rulesDriver"
        :submit="handleSubmitFormAddDriver"
        :title="$t('labels.driverModule.addDriver')"
        no-reset
        @close="closeOverSide">
        <div class="hts-vehicles-ignore-add-vehicle">
            <div class="hts-vehicles-ignore-add-vehicle__container-body">
                <hts-card :title="$t('labels.generalInformation')">
                    <div
                        class="grid gap-4"
                        :class="columnClass">
                        <hts-form-input
                            v-model="dataFormAddDriver.fullName"
                            :label="$t('labels.fullName')"
                            :required="true"
                            :color="color"
                            name="fullName"
                            prop="fullName" />
                        <hts-form-input
                            v-model="dataFormAddDriver.idCardNumber"
                            :label="$t('labels.idCardNumber')"
                            :required="true"
                            :color="color"
                            name="idCardNumber"
                            prop="idCardNumber" />
                        <hts-select-cooperator
                            v-if="dataFormAddDriver.type === 1"
                            v-model="dataFormAddDriver.cooperator"
                            required
                            prop="company"
                            type-cooperator="PARTNER,VENDOR"
                            :label="$t('labels.company')" />
                        <hts-form-phone
                            v-model="dataFormAddDriver.phone"
                            :label="$t('labels.phone')"
                            required
                            prop="phone"
                            name="phone"
                            @updateCode="(val) => (dataFormAddDriver.phone.code = val)" />
                        <hts-form-input
                            v-model="dataFormAddDriver.email"
                            :label="$t('labels.email')"
                            :color="color"
                            :required="false"
                            name="email"
                            prop="email" />
                        <hts-select-user
                            v-model="dataFormAddDriver.companyUserId"
                            v-model:name="dataFormAddDriver.companyUserName"
                            :label="$t('labels.userAccount')"
                            prop="companyUserId"
                            :data-create-default="dataFormAddDriver"
                            creatable/>
                    </div>
                </hts-card>
            </div>
        </div>
    </hts-drawer>
</template>
<script setup lang="ts">
import form from './imports/form'
const visible = ref(false)

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
    required: true
  },
  color: {
    type: String,
    default: 'theme'
  },
  sizeSlideOver: {
    type: String,
    default: 'small'
  },
  sizeItemInput: {
    type: String,
    default: 'small'
  },
  column: {
    type: Number,
    default: 1
  }
})

const emits = defineEmits(['close', 'refreshTables', 'newDriver'])

const closeOverSide = () => {
  emits('close')
}

const listStatus = [
  {
    value: 1,
    label: $t('labels.ready')
  },
  {
    value: 2,
    label: $t('labels.notReally')
  },
  {
    value: 3,
    label: $t('labels.endOfContract')
  }
]

const dataFormAddDriver = reactive({ ...form.initDriver })

const undo = () => {
  Object.assign(dataFormAddDriver, { ...form.initDriver })
}

const handleSubmitFormAddDriver = () => {
  const api = $url.driver.driver.add
  $api(api, { body: dataFormAddDriver }).then((data) => {
    const resData: any = data?.data?.value

    if (resData?.success) {
      emits('refreshTables')
      emits('newDriver', resData.data)
      process.client && $toast().success($t('labels.addSuccess'))
      visible.value = false
      undo()
    }
  })
}

const columnClass = computed(() => {
  if ($lodash.inRange(props.column, 1, 12)) {
    return `grid-cols-${props.column}`
  }

  return 'grid-cols-1'
})

const open = () => {
  dataFormAddDriver.phone = {
    countryCode: 'Vietnam +84',
    phone: '',
    code: '+84'
  }
  visible.value = true
}
defineExpose({
  open
})
</script>
